module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-11-16 at 11.37.20.4166f2eb.jpeg";